<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
  </div>
</template>

<script>
import jwt from 'jsonwebtoken';
import themeConfig from '@/../themeConfig.js';
import functions from './utils/functions';
import { mapActions } from 'vuex';
import {
  updateStoreDataEmpresa,
  observableLocalStorage,
} from './services/multiple-empresa';

function getCompanyIdFromToken() {
  const token = localStorage.getItem('user-token');
  if (!token) return null;
  try {
    const decoded = jwt.decode(token);
    return decoded && decoded.id_empresa ? decoded.id_empresa : null;
  } catch {
    return null;
  }
}

export default {
  data() {
    return {
      execWatchRoute: false,
    };
  },
  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val);
    },
    $route(to) {
      if (this.execWatchRoute) {
        return;
      }

      const allowedRoutes = [
        'boleto',
        'contratoAdesao',
        'laudoVistoria',
        'novaPropostaUser',
        'painelAssistencia',
        'propostaBP',
      ];

      if (!allowedRoutes.includes(to.name)) {
        this.alternaEmpresa();
      }

      this.execWatchRoute = true;
    },
  },
  async created() {
    try {
      updateStoreDataEmpresa();
      observableLocalStorage();
      const companyId = getCompanyIdFromToken();
      this.loadTranslations(companyId);
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    ...mapActions('app', ['loadTranslations']),
    toggleClassInBody(className) {
      if (className == 'dark') {
        if (document.body.className.match('theme-semi-dark'))
          document.body.classList.remove('theme-semi-dark');
        document.body.classList.add('theme-dark');
      } else if (className == 'semi-dark') {
        if (document.body.className.match('theme-dark'))
          document.body.classList.remove('theme-dark');
        document.body.classList.add('theme-semi-dark');
      } else {
        if (document.body.className.match('theme-dark'))
          document.body.classList.remove('theme-dark');
        if (document.body.className.match('theme-semi-dark'))
          document.body.classList.remove('theme-semi-dark');
      }
    },
    handleWindowResize(event) {
      this.$store.dispatch('updateWindowWidth', event.currentTarget.innerWidth);
    },
    alternaEmpresa() {
      const userToken = localStorage.getItem('user-token');
      if (userToken) {
        const { id_empresa } = jwt.decode(userToken);

        if (id_empresa && id_empresa === 117) {
          this.$router.replace('/Login?idEmpresa=118');
        }
      }
    },
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleWindowResize);
    });
    this.$store.dispatch('updateWindowWidth', window.innerWidth);
    functions.setFavicon();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
};
</script>

<style>
input.has-error,
div.has-error.vs-input input,
div.has-error.v-select {
  border: 1px solid rgba(var(--vs-danger), 1) !important;
  border-radius: 5px;
}
div.has-error.v-select .vs__dropdown-toggle {
  border: 0px !important;
}

.floating-button {
  position: fixed;
  bottom: 1.5rem;
  z-index: 110;
  right: 2rem;
}
</style>
